import i18n from '@/i18n/i18n'
import OverduePaymentInformationService from "@/services/public/OverduePaymentInformationService";

const { t } = i18n.global

export const namespaced = true

export const actions = {
  getOverduePaymentInformation({}, params) {
    return new Promise((resolve, reject) => {
      OverduePaymentInformationService.getOverduePaymentInformation(params.hash)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
